import React from "react";
import HowItWorks from "@/components/Common/HowItWorks";
import TrustedByMany from "@/components/Common/TrustedByMany";
import FeaturedOn from "@/components/Common/FeaturedOn";
import FreeAppraisal from "@/components/Common/FreeAppraisal";
import Hero from "@/components/Common/Hero";
import { createClient } from "../../../../prismicio";
import { SliceZone } from "@prismicio/react";
import Metadata from "@/components/Metadata";
import FAQ from "@/components/Common/FAQ";
import Layout from "@/components/Layout";
import Breadcrumbs from "@/components/Common/Breadcrumbs";
import BrandWeBuy from "@/components/Bags";
import AboutMB from "@/components/Common/AboutMB";
import Spacer from "./Spacer";

const BagsBuyers = ({ page, globals }) => {
  const pageData = page?.data;
  const commonComponents = globals?.data;

  const components = {
    faqs: FAQ,
  };

  return (
    <Layout data={commonComponents}>
      <Metadata
        title={pageData?.metadata_title}
        description={pageData?.metadata_desc}
        image={pageData?.metadata_image?.url}
        path="/what-we-buy/designer-bags-buyers-nyc"
      />
      <Hero
        caption={pageData?.hero_caption || ""}
        title={pageData?.hero_title || ""}
        sideImage={pageData?.hero_side_image?.url || ""}
        sideImageMobile={pageData?.hero_mobile_side_image?.url || ""}
        backgroundImage={pageData?.hero_background_image}
        description={pageData?.hero_description || ""}
        features={pageData?.hero_feature_list || []}
        page="Bag Buyers"
      />
      <Spacer />
      <Breadcrumbs />
      <Spacer />
      <BrandWeBuy
        title={pageData?.brandwebuy_title || []}
        description={pageData?.brandwebuy_description || []}
        brandTitle={pageData?.brand_we_buy_tab_title || []}
        brandTabBag={pageData?.brand_we_buy_tab_bag || {}}
      />
      <Spacer />
      <HowItWorks data={pageData} />
      <Spacer />
      <TrustedByMany data={commonComponents} page="Bag Buyers" />
      <FeaturedOn data={commonComponents} />
      <Spacer />
      <AboutMB data={pageData} page="Bag Buyers" />
      <Spacer size={133} />
      <SliceZone slices={page?.data?.slices2} components={components} />
      <Spacer />
      <FreeAppraisal whiteBg data={pageData} page="Bag Buyers" />
      <Spacer />
    </Layout>
  );
};

export default BagsBuyers;

export async function getStaticProps({ previewData }) {
  const client = createClient({ previewData });

  const page = await client.getSingle("bags_page");
  const globals = await client.getSingle("globals");

  return {
    props: {
      page,
      globals,
    },
  };
}
